import { render, staticRenderFns } from "./SsFooter.vue?vue&type=template&id=9cc13c0a&scoped=true&"
import script from "./SsFooter.vue?vue&type=script&lang=js&"
export * from "./SsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc13c0a",
  null
  
)

export default component.exports